import * as React from "react";
import {
    USAGE_MAINTENANCE_TOOLBAR,
    ALL_ROLES,
    UPDATE_USAGES_ROLE,
    SEARCH_MATCHING_WORKS_TOOLBAR,
} from "../../../Consts";
import IRepertoireComponentDataItem from "../../../../redux/types/IRepertoireComponentDataItem";
import { clearModalSearchResults, nextWorkflowInSession, startWorkflowSession } from "../../../../redux/reducers/RepertoireReducer";
import { showYesNoPrompt, hideModal, showModal } from "../../../../redux/reducers/ModalReducer";
import { ITabReduxItem } from "../../../../redux/types/ITabReduxItem";
import { IDataActionToolbar } from "../../../../repertoire/types/IDataActionToolbar";
import ToolbarComponent from "../../../components/usageComponents/toolBar/ToolBarComponent";
import { IUsageGroupState } from "../../../../redux/types/IUsageGroupState";
import { IWorkflowSearchResult } from "../../../types/IWorkflowSearchResult";
import { ILookupDictionary } from "../../../../lookup/types/ILookupDictionary";
import { FormatFields } from "../../../../redux/types/FormatFields";
import { IWorkflowParams } from "../../../types/IWorkFlowParams";

export interface IUsageMaintenanceMatchingProductsToolbarProps {
    changesMade: boolean;
    hideModal: typeof hideModal;
    showModal: typeof showModal;
    showYesNoPrompt: typeof showYesNoPrompt;
    clearModalSearchResults?: typeof clearModalSearchResults;
    scroll: number;
    toolbarWidth: number;
    toolbarData: IRepertoireComponentDataItem;
    saveResultData: IRepertoireComponentDataItem;
    activeTab: number;
    tabs: ITabReduxItem[];
    searchWorks: () => void;
    resetMessageBanner: () => void;
    isNew?: boolean;
    currentUser?: string;
    usageMaintenanceGeneralDataViewData?: IRepertoireComponentDataItem;
    usageGroup: IUsageGroupState;
    workflowFieldsData?: IRepertoireComponentDataItem;
    isWorkflowSessionStarted?: boolean;
    startWorkflowSession?: typeof startWorkflowSession;
    cancelWorkflowSession?: (activeTab: number) => void;
    nextWorkflowItem?: typeof nextWorkflowInSession;
    skipWorkflowItem?: (
        activeTab: number
        , currentWorkflowIndex: number
        , workflows: IWorkflowSearchResult[]) => void;
    workflowSessionItems?: IWorkflowSearchResult[];
    currentWorkflowIndex?: number;
    isOpenForWorkflowSession?: boolean;
    skipWorkWorkflowItem: (
        activeTab: number
        , currentWorkflowIndex: number
        , workflows: IWorkflowSearchResult[]
        , lookups: ILookupDictionary
        , otherIndicatorsWorkFlagTypes: string[]
        , dataActions: IDataActionToolbar[]
        , workMaintenanceGeneralDataViewData: IRepertoireComponentDataItem
        , formats: FormatFields[]
        , readonlyIndicatorsWorkFlagTypes: string[]) => void;
    formatFields: FormatFields[];
    lookupValues: ILookupDictionary;
    refreshWorkDetails?: () => void;
    saveWorkflow?: (workflowparams: IWorkflowParams) => void;
    completeWorkflowOnSave: (value: boolean) => void;
    roles?: string[];
    updateWorkflowAndEntityStatus?: (workflowparams: IWorkflowParams, approvalStatus: boolean) => void;
    updateClaimWorkflowAndEntityStatus?: (workflowparams: IWorkflowParams, callFrom: string, refreshDetails: () => void) => void;
    showSearchCriteria?: (value: boolean) => void;
    paneIndex?:number;
    componentInstance?:string;
    isSearchCriteriaVisible?:boolean;
}

const OPEN_SEARCH_PRODUCT_TO_MATCH = "Open Search Product To Match";
const CLOSE_SEARCH_PRODUCT_TO_MATCH = "Close Search Product To Match";

export interface IUsageMaintenanceMatchingProductsToolbarState {
    dataAction: IDataActionToolbar[];
}

export type UsageMaintenanceMatchingProductsToolbarKeys = keyof IUsageMaintenanceMatchingProductsToolbarProps;

const UsageMaintenanceMatchingProductsToolbar: React.FC<IUsageMaintenanceMatchingProductsToolbarProps> = ({
    changesMade,
    hideModal,
    showModal,
    toolbarData,
    saveResultData,
    resetMessageBanner,
    roles,
    usageGroup,
    tabs,
    activeTab,
    showSearchCriteria,
    clearModalSearchResults,
    workflowFieldsData,
      showYesNoPrompt,
            scroll,
            toolbarWidth,
            isWorkflowSessionStarted,
            startWorkflowSession,
            cancelWorkflowSession,
            nextWorkflowItem,
            skipWorkflowItem,
            workflowSessionItems,
            currentWorkflowIndex,
            isOpenForWorkflowSession,
            skipWorkWorkflowItem,
            formatFields,
            lookupValues,
            refreshWorkDetails,
            saveWorkflow,
            updateWorkflowAndEntityStatus,
            updateClaimWorkflowAndEntityStatus,
            completeWorkflowOnSave,
            componentInstance,
            isSearchCriteriaVisible,
}) => {
    
    const searchWorkAction = (value) => {

    if (!value) {
            showSearchCriteria(true)
            setDataAction([{
                    action: () => searchWorkAction(true),
                    component: USAGE_MAINTENANCE_TOOLBAR,
                    method: SEARCH_MATCHING_WORKS_TOOLBAR,
                    name: CLOSE_SEARCH_PRODUCT_TO_MATCH,
                    icon: 'icon ms-Icon ms-Icon--Search',
                    isReadOnly: false
                }]);

        } else {
            showSearchCriteria(false)
      setDataAction( [{
                    action: () => searchWorkAction(false),
                    component: USAGE_MAINTENANCE_TOOLBAR,
                    method: SEARCH_MATCHING_WORKS_TOOLBAR,
                    name: OPEN_SEARCH_PRODUCT_TO_MATCH,
                    icon: 'icon ms-Icon ms-Icon--Search',
                    isReadOnly: false
                }]);
        }


    }

    const getDataActionLocal = () => {
        const actionList: IDataActionToolbar[] = [];
        let openSearch : IDataActionToolbar = {
            action: () => searchWorkAction(false),
            component: USAGE_MAINTENANCE_TOOLBAR,
            method: SEARCH_MATCHING_WORKS_TOOLBAR,
            name: OPEN_SEARCH_PRODUCT_TO_MATCH,
            icon: 'icon ms-Icon ms-Icon--Search',
            isReadOnly: false
        };
        if (isSearchCriteriaVisible) {
        openSearch = {
            action: () => searchWorkAction(true),
            component: USAGE_MAINTENANCE_TOOLBAR,
            method: SEARCH_MATCHING_WORKS_TOOLBAR,
            name: CLOSE_SEARCH_PRODUCT_TO_MATCH,
            icon: 'icon ms-Icon ms-Icon--Search',
            isReadOnly: false
        };
    }
        actionList.push(openSearch);
        return actionList;
    }

    const [dataAction, setDataAction] = React.useState<IDataActionToolbar[]>(getDataActionLocal());


    const getUpdateRoleDisabled = (): boolean => {
        if (roles && (roles.includes(UPDATE_USAGES_ROLE) || roles.includes(ALL_ROLES))) {
            return false;
        }
        return true;
    }

        const localChangesMade = getUpdateRoleDisabled() && changesMade
        return (
            <>
                 <ToolbarComponent
                    scroll={scroll}
                    usageGroup={usageGroup}
                    toolbarWidth={toolbarWidth}
                    saveResultData={saveResultData}
                    resetMessageBanner={resetMessageBanner}
                    changesMade={localChangesMade}
                    activeTab={activeTab}
                    tabs={tabs}
                    dataActionToolbar={dataAction}
                    showYesNoPrompt={showYesNoPrompt}
                    hideModal={hideModal}
                    showModal={showModal}
                    clearModalSearchResults={clearModalSearchResults}
                    isReadonly={undefined}
                    toolbarData={toolbarData}
                    component={componentInstance}
                    isNew={false}
                    workflowFieldsData={workflowFieldsData}
                    isWorkflowSessionStarted={isWorkflowSessionStarted}
                    startWorkflowSession={startWorkflowSession}
                    cancelWorkflowSession={cancelWorkflowSession}
                    nextWorkflowItem={nextWorkflowItem}
                    skipWorkflowItem={skipWorkflowItem}
                    workflowSessionItems={workflowSessionItems}
                    currentWorkflowIndex={currentWorkflowIndex}
                    isOpenForWorkflowSession={isOpenForWorkflowSession}
                    skipWorkWorkflowItem={skipWorkWorkflowItem}
                    lookupValues={lookupValues}
                    formatFields={formatFields}
                    refreshWorkDetails={refreshWorkDetails}
                    saveWorkflow={saveWorkflow}
                    roles={roles}
                    updateWorkflowAndEntityStatus={updateWorkflowAndEntityStatus}
                    updateClaimWorkflowAndEntityStatus={updateClaimWorkflowAndEntityStatus}
                    completeWorkflowOnSave={completeWorkflowOnSave}
                />
            </>
        );
}

export default UsageMaintenanceMatchingProductsToolbar;
